import styled from 'styled-components';

export const EstimateRulesStyled = styled.div<{ isMobile?: boolean }>`
  .wrap-banner {
    .Polaris-Banner {
      .Polaris-InlineStack {
        align-items: ${(props) => (props.isMobile ? 'flex-start' : 'center')};
      }
      .Polaris-Box {
        .Polaris-BlockStack {
          display: flex;
          align-items: ${(props) => (props.isMobile ? 'flex-start' : 'center')};
          flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')};
          justify-content: space-between;
          margin-right: 0.75rem;
        }
      }
      :nth-child(2) {
        margin-top: 0.75rem;
      }
    }
  }
  .Polaris-IndexTable .Polaris-IndexTable__TableCell {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
